export function projectPlacement(placement, pageInfo) {
  const rect = pageInfo.canvas.getBoundingClientRect()
  const dynamicScale = rect.width / pageInfo.pdfWidth
  return {
    cssLeft: placement.x * dynamicScale,
    cssTop:
      (pageInfo.pdfHeight - placement.y - placement.height) * dynamicScale,
    cssWidth: placement.width * dynamicScale,
    cssHeight: placement.height * dynamicScale,
  }
}

export function applyProjection(element, projection) {
  element.style.left = `${projection.cssLeft}px`
  element.style.top = `${projection.cssTop}px`
  element.style.width = `${projection.cssWidth}px`
  element.style.height = `${projection.cssHeight}px`
}
